/* eslint-disable no-undef */
(() => {
  const sectionName = 'ingridients-ds';

  if (sectionName in Shopify.theme.sections.registered) {
    const sections = document.querySelectorAll(`[data-section-type=${sectionName}]`);

    sections.forEach((section, index) => {
      if (index !== 0) {
        const linkTag = section.querySelector('link');
        const scriptTag = section.querySelector('script');

        linkTag.remove();
        scriptTag.remove();
      }
    });
  } else {
    const selectors = {
      container: '.ingredientsDS__wrapper',
      button: '.ingredientsDS__contentContentButton'
    }

    function scrollToSection(event) {
      event.preventDefault();

      const section = document.querySelector(event.target.getAttribute('href'));

      if (section) {
        const sectionOffset = section.offsetTop;

        window.scrollTo({
          top: sectionOffset,
          behavior: 'smooth'
        });
      };
    };

    const wrapper = document.querySelector(selectors.container);
    const buttonToScroll = wrapper.querySelector(selectors.button);

    if (buttonToScroll?.getAttribute('href').includes('#')) {
      buttonToScroll.addEventListener('click', scrollToSection);
    }
    Shopify.theme.sections.register(sectionName);
  }
})()
